export function getNow() {
    return Date.now();
}
//# sourceMappingURL=getNow.js.map